import { toChildArray, Component } from 'preact';

import PropTypes from 'prop-types';
import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import animatedScrollTo from './utils/animated-scroll-to';
import isMobileDevice from './utils/is-mobile';
import { getObjectValues } from './utils/helpers';
import Slide from './Slide';
import Controls from './Controls';

const scrollMode = {
  FULL_PAGE: 'full-page',
  NORMAL: 'normal',
};
class FullPage extends Component {
  constructor(props) {
    super(props);
    this.isViewportVisible = this.isViewportVisible.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onKeypress = this.onKeypress.bind(this);
    this.getSlidesCount = this.getSlidesCount.bind(this);
    this.getCurrentSlideIndex = this.getCurrentSlideIndex.bind(this);
    this.scrollNext = this.scrollNext.bind(this);
    this.scrollPrev = this.scrollPrev.bind(this);
    this.scrollToSlide = this.scrollToSlide.bind(this);
    this.renderControls = this.renderControls.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);

    this.isScrollPending = false;
    this.isScrolledAlready = false;
    this.slides = [];
    this.slidesCount = FullPage.getChildrenCount(toChildArray(this.props.children));
    this.touchSensitivity = 5;
    this.touchStart = 0;
    this.isMobile = null;
    this.scrollEnable = true;
    props.hook(this);

    this.state = {
      activeSlide: props.initialSlide,
    };
  }

  componentDidMount() {
    this.isMobile = isMobileDevice();
    if (this.isMobile) {
      document.addEventListener('touchmove', this.onTouchMove, { passive: false });
      document.addEventListener('touchstart', this.onTouchStart);
    } else {
      document.addEventListener('wheel', this.onScroll, { passive: false });
      document.addEventListener('keydown', this.onKeypress);
    }
    window.addEventListener('resize', this.onResize);

    this.onResize();
    this.scrollToSlide(this.props.initialSlide);
  }

  componentWillUnmount() {
    if (this.isMobile) {
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('touchstart', this.onTouchStart);
    } else {
      document.removeEventListener('wheel', this.onScroll);
      document.removeEventListener('keydown', this.onKeypress);
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.slides = [];

    for (let i = 0; i < this.slidesCount; i++) {
      this.slides.push(window.innerHeight * i);
    }

    this.setState({
      height: window.innerHeight,
    });

    const childrenArr = React.Children.toArray(toChildArray(this.props.children));
    const slides = childrenArr.filter(({ type }) => type === Slide);
    slides.forEach((slide) => {
      const slid = slide;
      slid.props.height = this.state.height;
    });
  }

  onTouchStart(evt) {
    this.touchStart = evt.touches[0].clientY;
    this.isScrolledAlready = false;
  }

  onTouchMove(evt) {
    if (this.props.scrollMode !== scrollMode.FULL_PAGE) {
      return;
    }

    evt.preventDefault();
    const touchEnd = evt.changedTouches[0].clientY;

    if (!this.isScrollPending && !this.isScrolledAlready) {
      if (this.touchStart > touchEnd + this.touchSensitivity) {
        this.scrollToSlide(this.state.activeSlide + 1);
      } else if (this.touchStart < touchEnd - this.touchSensitivity) {
        this.scrollToSlide(this.state.activeSlide - 1);
      }
    }
  }
  onScroll(evt) {
    evt.preventDefault();
    if (this.scrollEnable) {
      this.scrollEnable = false;
      if (this.props.scrollMode !== scrollMode.FULL_PAGE) {
        return;
      }
      if (this.isScrollPending) {
        return;
      }
      let { activeSlide } = this.state;
      if (this.isViewportVisible('.recommendation__contact') || this.isViewportVisible('.text--feedback-contact') || this.isViewportVisible('.footer')) {
        activeSlide++;
      }
      const scrollDown = (evt.wheelDelta || -evt.deltaY || -evt.detail) < 0;
      if (scrollDown) {
        activeSlide++;
      } else {
        activeSlide--;
      }
      this.scrollToSlide(activeSlide);
      setTimeout(
        () => {
          this.scrollEnable = true;
        },
        1400
      );
    }
  }

  onKeypress(evt) {
    if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp') {
      if (this.props.scrollMode !== scrollMode.FULL_PAGE) {
        return;
      }

      if (this.isScrollPending) {
        evt.preventDefault();
        return;
      }

      let { activeSlide } = this.state;
      if (this.isViewportVisible('.recommendation__contact')) {
        activeSlide++;
      }

      if (evt.key === 'ArrowDown') {
        activeSlide++;
      } else if (evt.key === 'ArrowUp') {
        activeSlide--;
      }

      this.scrollToSlide(activeSlide);
    }
  }

  getSlidesCount() { return this.slidesCount; }

  getCurrentSlideIndex() { return this.state.activeSlide; }

  isViewportVisible(elem) {
    const footer = document.querySelectorAll(elem);
    const footerContent = footer && footer.length > 0 ? footer[footer.length - 1] : null;
    const bounding = footerContent && footerContent.getBoundingClientRect();
    return (bounding && bounding.top >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
  }

  scrollNext() {
    this.scrollToSlide(this.state.activeSlide + 1);
  }

  scrollPrev() {
    this.scrollToSlide(this.state.activeSlide - 1);
  }

  scrollToBottom() {
    scroll.scrollToBottom();
  }

  scrollToSlide(slide) {
    if (!this.isScrollPending && slide >= 0 && slide < this.slidesCount) {
      const currentSlide = this.state.activeSlide;
      this.props.beforeChange({ from: currentSlide, to: slide });

      this.setState({
        activeSlide: slide,
      });

      this.isScrollPending = true;
      animatedScrollTo(this.slides[slide], this.props.duration, () => {
        this.isScrollPending = false;
        this.isScrolledAlready = true;

        this.props.afterChange({ from: currentSlide, to: slide });
      });
    } else if (this.isViewportVisible('#lastDesc')) {
      this.scrollToBottom();
    }
  }

  renderControls() {
    const { controls, controlsProps } = this.props;
    if (!controls) {
      return null;
    }

    const controlsBasicProps = {
      getCurrentSlideIndex: this.getCurrentSlideIndex,
      onNext: this.scrollNext,
      onPrev: this.scrollPrev,
      scrollToSlide: this.scrollToSlide,
      slidesCount: this.getSlidesCount(),
    };

    if (controls === true) {
      return (
        <Controls
          className="full-page-controls"
          {...controlsBasicProps}
          {...controlsProps}
        />
      );
    }

    const CustomControls = controls;
    return (
      <CustomControls {...controlsBasicProps} {...controlsProps} />
    );
  }

  render() {
    return (
      <div>
        {this.renderControls()}
        {toChildArray(this.props.children)}
      </div>
    );
  }
}

export default FullPage;

FullPage.propTypes = {
  afterChange: PropTypes.func,
  beforeChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  controls: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.func,
  ]),
  controlsProps: PropTypes.object,
  arrowControl: PropTypes.object,
  duration: PropTypes.number,
  initialSlide: PropTypes.number,
  scrollMode: PropTypes.oneOf(getObjectValues(scrollMode)),
  hook: PropTypes.func,
};

FullPage.defaultProps = {
  afterChange: () => { },
  beforeChange: () => { },
  hook: () => { },
  controls: false,
  controlsProps: {},
  arrowControl: true,
  duration: 700,
  initialSlide: 0,
  scrollMode: scrollMode.FULL_PAGE,
};

FullPage.getChildrenCount = (children) => {
  const childrenArr = React.Children.toArray(children);
  const slides = childrenArr.filter(({ type }) => type === Slide);
  return slides.length;
};